const DESHBOARD_API =
  process.env.REACT_APP_ACCOUNT_ENDPOINT + "/v1/accounts/subscribed";

export async function apiCall({
  url,
  onSuccess = () => {},
  onFailure = () => {},
}) {
  try {
    let data = await fetch(`${DESHBOARD_API}/${url}`);

    data.json().then((data) => {
      if (data?.statusCode === 200) {
        onSuccess(data.payload);
      } else {
        onFailure(data.message);
      }
    });
  } catch (err) {
    console.log(err);
    onFailure(err);
  }
}

export const allProduct = [
  {
    head: "desk",
    subHead:
      "Veemo support mainly focuses on the email support with wide range of other features and custom rules that you can just set as per your needs",
  },
  {
    head: "crm",
    subHead:
      "Veemo sales is our CRM based software that will help you better manage and interact with your customers in a better way and also supported with custom workflow rules to make your team more efficient",
  },
  {
    head: "chat",
    subHead:
      " Veemo chat mainly focuses on chat support that will resolve the issues quickly and efficiency to customer across all platforms. With complex features like video chat, Veemo chat will help your company for a seamless chat support",
  },
  {
    head: "talk",
    subHead:
      "Veemo talk mainly focuses on the calling and dialing customer support side, with the help of complex features like customised IVR, power dialer etc. Sign up to explore more of these",
  },
  {
    head: "guide",
    subHead:
      "Veemo guide mainly focuses in customer reviews regarding the product and helps in maintaining the overall customer satisfaction across multiple products",
  },
  {
    head: "survey",
    subHead:
      "Veemo survey mainly focuses also on customer feedback collection and customised survey creation as per the company requirements for the betterment of your company",
  },
];

export function getService(service) {
  const bindService = {
    desk: "support",
    crm: "sales",
  };

  return bindService[service] || service;
}
